import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#40A7FE";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#40A7FE",
    backgroundColor: "#1CA0F1",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  description: {
    width: "75%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  day: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  hours: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  amount: {
    width: "15%",
  },
});

const DetailPdfTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.day}>Day</Text>
    <Text style={styles.description}>Description Job</Text>
    <Text style={styles.hours}>Hours</Text>
  </View>
);

export default DetailPdfTableHeader;
